"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = void 0;
const getConfig = () => ({
    maxReloadAttemptsAllowed: 3,
    i18n: {
        tabNodeButton: {
            'en-US': 'Skip to main content',
            'es-US': 'Skip to main content'
        },
        increaseCaptionsButton: {
            'en-US': 'increase captions size',
            'es-US': 'aumentar el tamaño de los subtítulos'
        },
        decreaseCaptionsButton: {
            'en-US': 'decrease captions size',
            'es-US': 'disminuir el tamaño de los subtítulos'
        },
        modalKeyboardInstructions: {
            'en-US': 'modal opened, use arrow keys to move modal',
            'es-US': 'modal abierto, use las teclas de flecha para mover modal'
        },
        toggleNarrationButton: {
            'en-US': 'select to include narrated video',
            'es-US': 'seleccionar para incluir video narrado'
        },
        toggleNarration: {
            'en-US': 'Narration',
            'es-US': 'Narración'
        }
    },
    defaultA11ySettings: {
        displaySettings: {
            contentScaling: 100,
            animations: false
        },
        audioSettings: {
            displayAudioControls: false,
            volume: 100,
            muteSounds: false
        },
        closedCaptionsSettings: {
            displayCCControl: false,
            showClosedCaptions: false,
            closedCaptionSize: 16
        },
        videoNarrationSettings: {
            showSettings: false
        }
    }
});
exports.getConfig = getConfig;
